import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import Section from './Section';
import Timeline from './Timeline';
import { education } from '../../data/profile';

export default function Education() {
    const items = education.map((e) => ({ ...e, subtitle: e.place }));
    return (
        <Section id="formacion" eyebrow="Perfil académico" title="Formación" muted>
            <Timeline items={items} icon={<SchoolOutlinedIcon />} />
        </Section>
    );
}
